import { Endpoint, Http } from "Application/Helpers/BaseEndpoint";
import { AppUrls } from "AppUrls";

export interface SaveActivityOptionsRequest {
    name: string;
}

export interface SaveActivityOptionsResponse {
    id: string | null;
    name: string | null;
    type: string | null;
    ordinal: number;
    isDeleted: boolean;
}

export class SaveActivityOptionsEndpoint extends Endpoint<SaveActivityOptionsRequest, SaveActivityOptionsResponse> {
    constructor() {
        super();
        this.verb(Http.Post);
        this.path(AppUrls.Server.Student.StudentSessions.PostSaveSessionActivity);
    }

    public async HandleRequestAsync(request: SaveActivityOptionsRequest): Promise<SaveActivityOptionsRequest> {
        return request;
    }

    public async HandleResponseAsync(response: SaveActivityOptionsResponse): Promise<SaveActivityOptionsResponse> {
        return response;
    }
}
